import React from "react";
import { Link } from "react-router-dom";

function Complete() {
  return (
    <div className="center">
      <h1 className="headline" style={{ marginBottom: "0px" }}>
        Top 3 Ways to Convert
      </h1>

      <div style={{ display: "flex" }}>
        <div className="pricing-card" style={{ width: "340px" }}>
          <div className="price" style={{ margin: "20px 0" }}>
            1. Send URL
          </div>
          <video
            controls
            autoPlay
            loop
            muted
            src="https://audiblogs-samples-new.s3.us-east-1.amazonaws.com/demo/clip.mp4"
            type="video/mp4"
            style={{
              width: "100%",
              borderRadius: "9px",
            }}
          />
          <div className="details">
            <div>
              This is your go-to method that should work most of the time.
            </div>
          </div>
        </div>
        <div className="pricing-card" style={{ width: "340px" }}>
          <div className="price" style={{ margin: "20px 0" }}>
            2. Upload PDF
          </div>
          <video
            controls
            autoPlay
            loop
            muted
            src="https://audiblogs-samples-new.s3.us-east-1.amazonaws.com/demo/upload.mp4"
            type="video/mp4"
            style={{
              width: "100%",
              borderRadius: "9px",
            }}
          />

          <div className="details">
            <div>
              Use this if you have a file downloaded or a PDF URL that requires
              private access.
            </div>
          </div>
        </div>
        <div className="pricing-card" style={{ width: "340px" }}>
          <div className="price" style={{ margin: "20px 0" }}>
            3. Select Text
          </div>
          <video
            controls
            autoPlay
            loop
            muted
            src="https://audiblogs-samples-new.s3.us-east-1.amazonaws.com/demo/select.mp4"
            type="video/mp4"
            style={{
              width: "100%",
              borderRadius: "9px",
            }}
          />

          <div className="details">
            <div>
              Use this if the web page is not publicly accessible (private or
              paid content).
            </div>
          </div>
        </div>
      </div>
      {/* <div
        className="cta-div"
        style={{ position: "static", marginTop: "24px" }}
      >
        <button className="cta-button">
          <Link to="/setupnew" style={{ textDecoration: "none" }}>
            Connect Podcast App
          </Link>
        </button>
      </div> */}
           <div
        className="cta-div"
        style={{ position: "static", marginTop: "24px" }}
      >
        <button className="cta-button">
          <Link to="/add" style={{ textDecoration: "none" }}>
            Go to App
          </Link>
        </button>
      </div>
    </div>
  );
}

export default Complete;
